<template>
  <div
    id="app"
    :class="{
      'has-environment-indicator': !isProduction,
      'has-chatbox': shouldDisplayZendeskChatLauncher,
    }"
    :dir="currentDirection"
  >
    <router-view />
    <ZendeskButton v-if="shouldDisplayZendeskChatLauncher" />
    <VerifyPhoneNumber />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import locator from '@/service-locator'
import CHATBOT from '@/constants/chatbot'
import ZendeskButton from '@/components/Zendesk/chatbot-button.vue'
import VerifyPhoneNumber from '@/containers/VerifyPhoneNumber/VerifyPhoneNumber.vue'

export default {
  name: 'App',
  components: { ZendeskButton, VerifyPhoneNumber },
  computed: {
    ...mapGetters('chatbot', ['zendeskChatbotReady']),
    ...mapGetters('configuration', ['chatbotServiceProvider']),
    ...mapGetters('translations', ['currentDirection', 'currentLang']),
    ...mapGetters('chatbot', ['zendeskChatbotReady']),
    isProduction() {
      return locator.config.isProduction
    },
    shouldDisplayZendeskChatLauncher() {
      return (
        this.chatbotServiceProvider === CHATBOT.zendesk &&
        this.zendeskChatbotReady
      )
    },
  },
  watch: {
    currentLang(newValue) {
      locator.chatbot.changeChatBotLanguage(newValue)
    },
    currentDirection(newValue) {
      document.documentElement.setAttribute('dir', `${newValue}`)
    },
  },
}
</script>

<style lang="scss" scoped>
#app {
  --spacing-for-chatbox: 0;

  &.has-chatbox {
    --spacing-for-chatbox: 88px;
  }
}
</style>
